import {ReactNode} from "react";

import {useHiddenPricesRegistrationHandler} from "../../hooks/use_hidden_prices_registration_handler";
import {IGTMEventLeadForm} from "../../tracking/google_tag_manager/gtm_event_form_open";
import {useApplicationModalButtonAmplitudeOpenTracking} from "../hooks/use_application_modal_button_amplitude_open_tracking";
import {MainLeadDataPayload} from "../types/lead/MainLeadDataPayload";
import {ApplicationModalButton, IApplicationModalButtonRenderProps} from "./ApplicationModalButton";

export interface IApplicationModalButtonWithHiddenPricesRenderProps extends IApplicationModalButtonRenderProps {
    handleClick: () => void;
    priceRevealButtonTestId?: string;
}

type IProps = {
    render: (props: IApplicationModalButtonWithHiddenPricesRenderProps) => ReactNode;
    shouldShowPrice: boolean;
    gtmData: IGTMEventLeadForm;
    onOpen?: () => void;
    onEveryOpen?: () => void;
    onClose?: () => void;
    openOnMount?: boolean;
} & Omit<MainLeadDataPayload, "gtmMeta" | "amplitudeLeadFormEventTracking">;

export const ApplicationModalButtonWithHiddenPrices = (props: IProps) => {
    const {render, shouldShowPrice, gtmData, ...applicationModalButtonProps} = props;

    const {getOpenModalTracking} = useApplicationModalButtonAmplitudeOpenTracking({
        vendorId: applicationModalButtonProps.vendorId,
        offerId: applicationModalButtonProps.offerId,
        propertyId: applicationModalButtonProps.propertyId,
        source: applicationModalButtonProps.source,
        sourceSection: applicationModalButtonProps.sourceSection,
        ctaText: gtmData.clickText
    });

    return (
        <ApplicationModalButton
            {...applicationModalButtonProps}
            render={({openModal, isOpened}) => {
                const {handleClick} = useHiddenPricesRegistrationHandler({
                    onAction: () => {
                        openModal(getOpenModalTracking(gtmData));
                    },
                    shouldShowPrice,
                    gtmData,
                    propertyId: applicationModalButtonProps.propertyId,
                    offerId: applicationModalButtonProps.offerId,
                    vendorId: applicationModalButtonProps.vendorId,
                    leadSource: applicationModalButtonProps.source,
                    leadSourceSection: applicationModalButtonProps.sourceSection
                });

                return render({openModal, isOpened, handleClick});
            }}
        />
    );
};
import {ReactNode} from "react";

import {useHiddenPricesRegistrationHandler} from "../../hooks/use_hidden_prices_registration_handler";
import {IGTMEventLeadForm} from "../../tracking/google_tag_manager/gtm_event_form_open";
import {useApplicationModalButtonAmplitudeOpenTracking} from "../hooks/use_application_modal_button_amplitude_open_tracking";
import {MainLeadDataPayload} from "../types/lead/MainLeadDataPayload";
import {ApplicationModalButton, IApplicationModalButtonRenderProps} from "./ApplicationModalButton";

export interface IApplicationModalButtonWithHiddenPricesRenderProps extends IApplicationModalButtonRenderProps {
    handleClick: () => void;
    priceRevealButtonTestId?: string;
}

type IProps = {
    render: (props: IApplicationModalButtonWithHiddenPricesRenderProps) => ReactNode;
    shouldShowPrice: boolean;
    gtmData: IGTMEventLeadForm;
    onOpen?: () => void;
    onEveryOpen?: () => void;
    onClose?: () => void;
    openOnMount?: boolean;
} & Omit<MainLeadDataPayload, "gtmMeta" | "amplitudeLeadFormEventTracking">;

export const ApplicationModalButtonWithHiddenPrices = (props: IProps) => {
    const {render, shouldShowPrice, gtmData, ...applicationModalButtonProps} = props;

    const {getOpenModalTracking} = useApplicationModalButtonAmplitudeOpenTracking({
        vendorId: applicationModalButtonProps.vendorId,
        offerId: applicationModalButtonProps.offerId,
        propertyId: applicationModalButtonProps.propertyId,
        source: applicationModalButtonProps.source,
        sourceSection: applicationModalButtonProps.sourceSection,
        ctaText: gtmData.clickText
    });

    return (
        <ApplicationModalButton
            {...applicationModalButtonProps}
            render={({openModal, isOpened}) => {
                const {handleClick} = useHiddenPricesRegistrationHandler({
                    onAction: () => {
                        openModal(getOpenModalTracking(gtmData));
                    },
                    shouldShowPrice,
                    gtmData,
                    propertyId: applicationModalButtonProps.propertyId,
                    offerId: applicationModalButtonProps.offerId,
                    vendorId: applicationModalButtonProps.vendorId,
                    leadSource: applicationModalButtonProps.source,
                    leadSourceSection: applicationModalButtonProps.sourceSection
                });

                return render({openModal, isOpened, handleClick});
            }}
        />
    );
};
